export function useMetricScalePath(key: string, isStarMetric: boolean) {
  if (key === 'spread') {
    return '/spread/spread';
  }

  return `/${isStarMetric ? 'star' : 'line'}/${key}`;
}
